<template>
  <div>
    <div class="container-fluid m-0 p-0">
      <div class="row justify-content-center">
        <div class="col-md-2 t-center mt-5 pt-5">
          <img src="@/assets/A+.png" alt="CompTIA A+ Logo" class="img-fluid mb-3"
          />
        </div>
      </div>

      <div class="row bg-white pt-5 pb-5 ms-5 border-bottom">
        <div class="col-md-1 p-0 t-center">Kapitel</div>
        <div class="col-md-2 p-0 t-center">PDF</div>

        <div class="col-md-3 p-0 t-center">Bezeichnung</div>
        <div class="col-md-2 p-0 t-center">Quiz</div>
        <div class="col-md-3 p-0 t-center">Link</div>
      </div>

      <div class="row ms-5" v-for="i in 31" :key="i">
        <div class="col-md-1 p-0 t-center">{{ i }}</div>
        <div class="col-md-2 p-0 t-center">
          <a :href="`/PDF/${$data['PDF' + i]}`" download v-if="$data['PDF' + i]">
            <button class="btn btn-success p-1 m-1" style="min-width: 100px">
              PDF {{ i }}
            </button>
          </a>

          <a
            :href="`/PDF/${$data['PDF' + i + 'a']}`"
            download
            v-if="$data['PDF' + i + 'a']"
          >
            <button class="btn btn-success p-1 m-1" style="min-width: 100px">
              PDF {{ i }}
            </button>
          </a>
        </div>
        <div class="col-md-3 p-0 t-center">
          {{ $data["Titel" + i] }}
        </div>

        <div class="col-md-2 p-0 t-center">
          <a :href="$data['Link' + i]" target="_blank" v-if="$data['Link' + i]">
            <button class="btn btn-primary p-1 m-1" style="min-width: 160px">
              Zum Quiz {{ i }}
            </button>
          </a>
        </div>

        <div class="col-md-4 p-0 t-center">
          {{ $data["Link" + i] }}
        </div>
      </div>
      <h2 class="ps-5 pt">Ergänzungen</h2>
      <div class="row ms-5" v-for="i in 30" :key="i">
        <div class="col-md-1 p-0 t-center"></div>
        <div class="col-md-1 p-0 t-center">
          <a
            :href="`/PDF/${$data['PDF_sonstige' + i]}`"
            download
            v-if="$data['PDF_sonstige' + i]"
          >
            <button class="btn btn-secondary p-1 m-1" style="min-width: 100px">
              PDF Sonstige {{ i }}
            </button>
          </a>
        </div>
        <div class="col-md-3 p-0 t-center">
          {{ $data["PDF_sonstige" + i] }}
        </div>
      </div>
      <h2 class="ps-5 pt">90 Fragen Quiz</h2>
      <div class="row ms-5" v-for="i in 10" :key="i">
        <div class="col-md-1 p-0 t-center"></div>
        <div class="col-md-2 p-0 t-center">
          <a :href="$data['quiz90_' + i]" target="_blank" v-if="$data['quiz90_' + i]">
            <button class="btn btn-primary p-1 m-1" style="min-width: 160px">
              Zum Quiz {{ i }}
            </button>
          </a>
        </div>
        <div class="col-md-9 p-0 t-center">
          {{ $data["quiz90_" + i] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KapitelfragenQuizPage_A_Plus",

  data() {
    return {
      newSite: null,
      Titel1: "Sprechen Sie Computer?",
      Titel2: "-",
      Titel3: "Vom Bit bis zum Personal Computer",
      Titel4: "Einblick in die Systemarchitektur",
      Titel5: "Externe Schnittstellen",
      Titel6: "Interne und externe Geräte",
      Titel7: "Ein- und Ausgabegeräte",
      Titel8: "Drucker",
      Titel9: "Grundlegende Betriebskonzepte",
      Titel10: "Ein Computersystem aufrüsten",
      Titel11: "Mobile Systeme erweitern",
      Titel12: "Unterhalt von Druckern",
      Titel13: "Mobile Systeme unterhalten und reparieren",
      Titel14: "Aus die Maus — was NUM?",
      Titel15: "Häh? — Kommunikation im Support",
      Titel16: "Einführung in die Welt der Netzwerke",
      Titel17: "Netzwerkprotokolle und -dienste",
      Titel18: "Von Wolken und künstlicher Intelligenz",
      Titel19: "Netzwerke einrichten",
      Titel20: "Netzwerkunterhalt und Fehlersuche",
      Titel21: "Was betreibt ein Betriebssystem?",
      Titel22: "Die Installation von Windows",
      Titel23: "Die Konfiguration von Windows 10",
      Titel24: "Die Konfiguration von Windows 11",
      Titel25: "Unterhalt und Wartung für Windows",
      Titel26: "Installation und Konfiguration von macOS",
      Titel27: "Installation und Konfiguration von LinuX",
      Titel28: "Die Welt ist böse",
      Titel29: "Sicherheitsmaßnahmen ergreifen",
      Titel30: "So schützen Sie Ihre Systeme",
      Titel31: "Datenschutz und Datensicherheit",
      Link1: "https://forms.cloud.microsoft/e/iv3mNYbR6M?origin=lprLink",
      Link2: "",
      Link3: "https://forms.cloud.microsoft/e/Kz7rPqDVNA?origin=lprLink",
      Link4: "https://forms.cloud.microsoft/e/SdgpQHdJvn?origin=lprLink",
      Link5: "https://forms.cloud.microsoft/e/uuAcgk2acN?origin=lprLink",
      Link6: "https://forms.cloud.microsoft/e/B4g6DEd0ra?origin=lprLink",
      Link7: "https://forms.cloud.microsoft/e/AM8vDndUAV?origin=lprLink",
      Link8: "https://forms.cloud.microsoft/e/9vJJX1vLHt?origin=lprLink",
      Link9: "https://forms.cloud.microsoft/e/3KYay9hLcp?origin=lprLink",
      Link10: "https://forms.cloud.microsoft/e/Y3Sqc4Tewb?origin=lprLink",
      Link11: "https://forms.cloud.microsoft/e/uC7YurMKQS?origin=lprLink",
      Link12: "https://forms.cloud.microsoft/e/ucTusEX3Xj?origin=lprLink",
      Link13: "https://forms.cloud.microsoft/e/1MD2ZFnMEb?origin=lprLink",
      Link14: "https://forms.cloud.microsoft/e/9RtZMDTiUj?origin=lprLink",
      Link15: "https://forms.cloud.microsoft/e/rq7tNr0fsD?origin=lprLink",
      Link16: "https://forms.cloud.microsoft/e/DXT64EUKVw?origin=lprLink",
      Link17: "https://forms.cloud.microsoft/e/RNSV2gpuh1?origin=lprLink",
      Link18: "https://forms.cloud.microsoft/e/FLHqPcbzim?origin=lprLink",
      Link19: "https://forms.cloud.microsoft/e/urvL5LRmK2?origin=lprLink",
      Link20: "https://forms.cloud.microsoft/e/Gt383A5X20?origin=lprLink",
      Link21: "https://forms.cloud.microsoft/e/kLgaLK1ghv?origin=lprLink",
      Link22: "https://forms.cloud.microsoft/e/suq0KUDnDE?origin=lprLink",
      Link23: "https://forms.cloud.microsoft/e/EWhXsk0PpQ?origin=lprLink",
      Link24: "https://forms.cloud.microsoft/e/LfpiSJPkc3?origin=lprLink",
      Link25: "https://forms.cloud.microsoft/e/vxmD2f8uaM?origin=lprLink",
      Link26: "https://forms.cloud.microsoft/e/ictDkpRj5k?origin=lprLink",
      Link27: "https://forms.cloud.microsoft/e/VZ7pLhm0um?origin=lprLink",
      Link28: "https://forms.cloud.microsoft/e/b1W24RYc8f?origin=lprLink",
      Link29: "https://forms.cloud.microsoft/e/b5hRWfuFRM?origin=lprLink",
      Link30: "https://forms.cloud.microsoft/e/3TXhcDyE0J?origin=lprLink",
      Link31: "https://forms.cloud.microsoft/e/gkm71VGVv8?origin=lprLink",
      PDF1: "",
      PDF1a: "",
      PDF2: "",
      PDF2a: "",
      PDF3: "3-1 Vom Bit bis zum Personal Computer.pdf",
      PDF3a: "3-3 Geschichte des Personal Computers.pdf",
      PDF4: "4-1 Einblick in die Systemarchitektur.pdf",
      PDF4a: "4-2 Mainboard-Komponenten.pdf",
      PDF5: "5 - Externe Schnittstellen.pdf",
      PDF5a: "",
      PDF6: "6 - Speichermedien.pdf",
      PDF6a: "",
      PDF7: "7 - Ein und Ausgabegeräte.pdf",
      PDF7a: "",
      PDF8: "8 - Drucker.pdf",
      PDF8a: "",
      PDF9: "9 - Grundlegende Betriebskonzepte.pdf",
      PDF9a: "",
      PDF10: "10 - Computer ausrüsten.pdf",
      PDF10a: "",
      PDF11: "11 - Mobile Systeme erweitern.pdf",
      PDF11a: "",
      PDF12: "12 - Unterhalt von Druckern.pdf",
      PDF12a: "",
      PDF13: "13 – Mobile Systeme.pdf",
      PDF13a: "",
      PDF14: "14 – Fehlerdiagnose.pdf",
      PDF14a: "",
      PDF15: "15 - Support.pdf",
      PDF15a: "",
      PDF16: "16 - Netzwerke.pdf",
      PDF16a: "",
      PDF17: "17 - Netzwerkprotokolle.pdf",
      PDF17a: "",
      PDF18: "18 - Cloud_KI.pdf",
      PDF18a: "",

      PDF19: "19 - Netzwerke Einrichten.pdf",
      PDF19a: "",
      PDF20: "20 - Netzwerkunterhalt Fehlersuche.pdf",
      PDF20a: "",
      PDF21: "21 - Was betreibt ein Betriebssystem.pdf",
      PDF21a: "",
      PDF22: "22 - Die Installation von Windows.pdf",
      PDF22a: "",
      PDF23: "23 - Konfiguration Windows 10.pdf",
      PDF23a: "",
      PDF24: "24 - Konfiguration Windows 11.pdf",
      PDF24a: "",
      PDF25: "25 - Unterhalt und Wartung für Windows.pdf",
      PDF25a: "",
      PDF26: "26 - macOS_Installation.pdf",
      PDF26a: "",
      PDF27: "27 - Linux.pdf",
      PDF27a: "27a - Linux_Befehle_Vollstaendig.pdf",
      PDF28: "28 - IT_Sicherheit_Grundlagen.pdf",
      PDF28a: "",
      PDF29: "29 - Sicherheitsmassnahmen.pdf",
      PDF29a: "",
      PDF30: "30 - Systemschutz.pdf",
      PDF30a: "",
      PDF31: "31 - Datensicherung.pdf",
      PDF31a: "",


      PDF_sonstige1: "17-x - IP4-Netzwerklassen.pdf",
      PDF_sonstige2: "17 - x - DHCP_DORA_Grundlagen.pdf",
      PDF_sonstige3: "17 - x - DNS_Ablauf.pdf",
      PDF_sonstige4: "HTTP3_Troubleshooting.pdf",
      PDF_sonstige5: "Linux_Befehle_Vollstaendig.pdf",
      PDF_sonstige6: "RAID_Gesamtübersicht.pdf",
      PDF_sonstige7: "Vergleich VLAN Subnetting zu Macfilter.pdf",
      PDF_sonstige8: "",
      PDF_sonstige9: "",
      PDF_sonstige10: "",
      PDF_sonstige11: "",
      PDF_sonstige12: "",
      PDF_sonstige13: "",
      PDF_sonstige14: "",
      PDF_sonstige15: "",
      PDF_sonstige16: "",
      PDF_sonstige17: "",
      PDF_sonstige18: "",
      PDF_sonstige19: "",
      PDF_sonstige20: "",
      quiz90_1: "https://forms.cloud.microsoft/e/cnNE469njH?origin=lprLink",
      quiz90_2: "https://forms.cloud.microsoft/e/rZuX1tKqcL?origin=lprLink",
      quiz90_3: "",
      quiz90_4: "",
      quiz90_5: "",
      quiz90_6: "",
      quiz90_7: "",
      quiz90_8: "",
      quiz90_9: "",
      quiz90_10: "",
    };
  },
  components: {},
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
